import { AxiosResponse } from 'axios'
import { apiWebClient } from '@/services/client'
import ApiConfig from '@/services/api.config'
import { DJingle } from '@/services/api.types'

export default async function fetchJingles(): Promise<AxiosResponse<DJingle[]>> {
  return apiWebClient.get(ApiConfig.djingle)
}
